<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <!-- <start-study v-show="!isStart" v-bind:studyInfo="studyInfo" @onStart="onStart"/> -->
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="그림카드 선택 후 음가에 유의해 단어를 들어보세요." icon-pack="feather" icon="icon-info"></vs-list-header>
        <!-- <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ getFinishedWordCount() }} / {{contentsLen}}</vs-chip>
        </vs-list-item> -->
      </vs-list>

      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <vs-alert active="true" color="danger" icon-pack="feather" icon="icon-star">
            그림카드를 클릭하세요! 음가와 단어의 발음이 출력됩니다. 
          </vs-alert>
        </div>
        
        <div class="vx-col sm:w-1/3 md:w-1/3 w-full mb-4" :key="index" v-for="(item, index) in contentList">
            <vx-card class="phonics-sm-card flex items-center justify-center" @click="onImageClick(index)">
              <flip-card :flip="item.finished" :prevent-event="isStudying">
                <template slot="back" class="phonics-sm-card">
                  <div class="mb-4">
                    <h2 class="text-primary sentence text-center">{{ item.sentence }}</h2>
                    <br>
                    <h2 class="text-primary sentence text-center"> {{ item.translation}} </h2>
                  </div>
                </template>
                <template slot="front">
                  <div slot="no-body">
                    <img :src="item.image" class="image-card-height">
                  </div>
                </template>
              </flip-card>
            </vx-card>
        </div>
      </div>
      <div class="text-center mt-6 hidden">
        <audio ref="audioPlayer1" 
          controls 
          v-on:ended="audio1Finish" 
          controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>

        <audio ref="audioPlayer2" 
          controls 
          v-on:ended="audio2Finish" 
          controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>

      </div>  
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" ></top-button-bar>
  </div>  
</div>
</template>

<script>

const NEXT_WORD_INTERVAL = 1000
const REPEAT_WORD_INTERVAL = 500

import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      page: 0,
      totalContentList: [],

      alphabetContent: {},
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      hideImage: false,
      repeat: 0,
      isStudying: false,
      reset: false

    }
  },
  watch: {
    
  },
  computed: {

    audioPlayer1 () {
      return this.$refs.audioPlayer1
    },
    audioPlayer2 () {
      return this.$refs.audioPlayer2
    },
    content () {
      return this.contentList[this.contentIndex]
    }
  },
  methods: {
    
    onImageClick (index) {
      if (this.isStudying) return
      if (this.contentList[index].finished) return
      
      this.isStudying = true
      this.contentList[index].finished = true
      this.contentIndex = index
      this.playAudio(this.audioPlayer1, this.alphabetContent.audio)
    },
    onReload () {

      for (let i = 0; i < this.totalContentList.length; i++) {
        const arrTemp = this.totalContentList[i]
        arrTemp.forEach(function (element) {
          element.finished = false
        })
      }

      this.isStudying = false
      this.page = 0
      this.contentList = this.totalContentList[0]
      this.audioPlayer1.pause()
      this.audioPlayer2.pause()
      this.contentIndex = 0
      this.startAlert()
    },
    getFinishedWordCount () {
      let cnt = 0
      this.contentList.forEach(function (element) {
        if (element.finished) {
          cnt++
        }
      })
      return cnt
    },
    playAudio (audioPlayer, src) {
      if (this.studyFinished) return
      audioPlayer.src = src
      audioPlayer.play()
    },
    audio1Finish () {
      
      setTimeout(function () {
        this.repeat = 0
        this.playAudio(this.audioPlayer2, this.content.audio)
      }.bind(this), NEXT_WORD_INTERVAL)
      
    },
    audio2Finish () {
      if (this.repeat === 0) {
        this.repeat++
        setTimeout(function () {
          this.playAudio(this.audioPlayer2, this.content.audio)
        }.bind(this), REPEAT_WORD_INTERVAL)
      } else {
        
        let completed = true
        for (let i = 0; i < this.contentList.length; i++) {
          if (this.contentList[i].finished === false) {
            completed = false
            break
          }
        }

        if (completed) {
          if (this.page === (this.totalContentList.length - 1)) {
            this.onComplete()
          } else {
            this.page++
            this.contentList = this.totalContentList[this.page]
            this.isStudying = false
          }
        } else {
          this.isStudying = false
        }
      }
    },
    startAlert () {
      this.startStudyDlg('그림카드 선택 후 음가에 유의해 단어를 들어보세요.')
    },
    chunk (arr, size) {
      let i, j, temparray = [], chunk = size
      for (i = 0, j = arr.length; i < j; i += chunk) {
        temparray.push(arr.slice(i, i + chunk))
      }
      return temparray
    }

  },
  created () {
    
    const contentJson = JSON.parse(this.sourceContent.contentBody)
    this.alphabetContent.sentence = contentJson.sentence[0]
    this.alphabetContent.audio = this.$buildAudioPath(this.sourceContent.contentCode, 1).replace('AP1', 'AP2')

    // 1번엔 대표 발음이 들어 있음. 단어의 발음은 2부터 이미지는 1부터
    const arrContent = new Array()
    for (let i = 1; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1).replace('AP1', 'AP2'),
        image: this.$buildImagePath(this.sourceContent.contentCode, i).replace('AP1', 'AP2'),
        finished: false
      } 
      arrContent.push(content)
    }
    // 컨텐츠를 6개씩 나눈다.
    this.totalContentList = this.chunk(arrContent, 6)
    this.contentList = this.totalContentList[0]
    this.contentsLen = this.contentList.length
    this.startAlert()
  },
  mounted () {
    
  },
  beforeDestroy () { 
    this.audioPlayer1.pause()
    this.audioPlayer2.pause()
  }
}

</script>

<style scoped>
.image-card {
  height: 360px
}
.image-box {
    
    height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image-box img {
    max-width: 100%;
    max-height: 100%;
}
</style>
